export default {
    general: {
        name: 'Kalamaio',
        welcome: 'Benvenuto in Kalamaio VIP',
        description: 'Stiamo costruendo un nuovo modo di comunicare.'
    },
    messages: {
        discovermoreon: 'Scopri di piú su'
    }
};
